window.filterRendered = function() {
    window.adBlocks()

    setTimeout(function () {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();

    }, 500)

    $(document).ready(function () {
        $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-title-heading').on('click', function (e) {
            if (e.hasOwnProperty('originalEvent')) {
                if ($(this).parents('.boost-pfs-filter-option-product').length) {
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-benefit:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-certification:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                } else if ($(this).parents('.boost-pfs-filter-option-benefit').length) {
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-product:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-certification:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                } else if ($(this).parents('.boost-pfs-filter-option-certification').length) {
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-product:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                    $('.boost-pfs-filter-tree-mobile-sticky .boost-pfs-filter-option-benefit:not(.boost-pfs-filter-option-collapsed) .boost-pfs-filter-option-title-heading').click()
                }
            }
        })
    })
}
